<template>
    <!-- display the total sum of item prices inside the cart in local currency -->
    <span>{{cartItemsPriceTotal.currency.toUpperCase()}} {{cartItemsPriceTotal.price | money}}</span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: "CartSumPrice",
    data() {
        return {
            cartItemPrice: null
        }
    },
    methods: {
        ...mapActions(['cartItemsPriceSumAction']),
        updateCartPriceSum() {
            // update cart items price sum via vuex action
            this.cartItemsPriceSumAction().then(() => {}).catch((e) => {})
        }
    },
    computed: {
        ...mapGetters(['cartItemsPriceSum', 'setCurrency']),
        cartItemsPriceTotal() {
			// display count to summed up cart items prices
            if(this.cartItemsPriceSum) {
                // here is the summed up prices of items inside the cart
                let cartItemPriceObj = {
                    price: this.cartItemsPriceSum
                }
                // convert the item price from US Dollar to Nigeria Naira using our rate
                if(this.theCurrency){
                    cartItemPriceObj.price *= this.theCurrency.rate
                    cartItemPriceObj.currency = this.theCurrency.code
                }
                return cartItemPriceObj
            }
            return 0 // show empty sum by default
		},
        theCurrency() {
            if(this.setCurrency) {
                return this.setCurrency
            }
            return false
        },
    },
    created() {
        // auto load and display cart items prices sum if any
        this.updateCartPriceSum()
    }
}
</script>
